import Header from "../home/header"
import Websiteheader from "./websiteheader"
import Webdescription from "./webDescription"
import Technologies from "../home/technologies" 
import HowwebuildProject from "../home/howwebuildProject"
import Contactnow from "../home/contactnow"
import Footer from "../home/footer"
import Dreamcontact from "../home/dreamcontact"
const websitepage=()=>{
    return(
        <>    
            <Header/>
            <Websiteheader/>
            <Webdescription/>
            <Technologies/>
            <HowwebuildProject/>
            <Dreamcontact/>
            <Footer/>
        </>
    )
}

export default websitepage